import {FETCH_ALL_MEETINGS, FETCH_COMMITTEE_MEETING , REMOVE_MEETINGS} from '../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_ALL_MEETINGS:
			return action.payload;
			break;
		case FETCH_COMMITTEE_MEETING:
			let newState = Object.assign({}, state);
			newState[action.payload.ccode] = action.payload.data;
			return newState;
			break;

		case REMOVE_MEETINGS:
			let removeState = Object.assign({}, state);
			delete removeState[action.payload.ccode];
			return removeState;
			break;
	}
	return state;
}